export default function ArrowTopRight({color = "#FFEAC0"}) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
            <path d="M1.81836 8.33341L8.70283 1.66675M8.70283 1.66675L1.81836 1.66675M8.70283 1.66675V8.33341" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}